import Vue from "vue";
import Router from "vue-router";
import meta from "./meta";

Vue.use(Router);
const componentsBox = {
  home: () => import("@/views/home"),
  activePage: () => import("@/views/active"),
  rankingList: () => import("@/views/rankingList"),
  turnOver: () => import("@/views/turnOver"),
  IntegralRecord: () => import("@/views/IntegralRecord"),
  store: () => import("@/views/store"),
  goodsDetail: () => import("@/views/goodsDetail"),
  sureMsg: () => import("@/views/sureMsg"),
  exchange: () => import("@/views/exchange"),
  exchangeDetail: () => import("@/views/exchangeDetail"),
  ticket: () => import("@/views/ticket"),
  ticketDetail: () => import("@/views/ticketDetail")
};

//在线培训
import Choice from "./../mobile/tation/choicegab.vue";
import ProductCategory from "./../mobile/tation/ProductCategory.vue";
import ProductSelect from "./../mobile/tation/ProductSelect.vue";
import ContentCategory from "./../mobile/tation/ContentCategory.vue";
import TrainingPDF from "./../mobile/tation/TrainingPDF.vue";

const router = new Router({
  mode: "history",
  routes: [
    { path: "/choicegab", name: "choicegab", component: Choice },
    {
      path: "/product-category",
      name: "product-category",
      component: ProductCategory
    },
    {
      path: "/product-select/:cate",
      name: "product-select",
      props: true,
      component: ProductSelect
    },
    {
      path: "/content-category/:cate",
      name: "content-category",
      props: true,
      component: ContentCategory
    },
    {
      path: "/training-pdf/:cate/:id",
      name: "training-pdf",
      props: true,
      component: TrainingPDF
    },
    {
      path: "/home",
      name: "home",
      component: componentsBox.home,
      meta: {
        title: meta.home
      }
    },
    {
      path: "/turnOver",
      name: "turnOver",
      component: componentsBox.turnOver,
      meta: {
        title: meta.turnOver
      }
    },
    {
      path: "/IntegralRecord",
      name: "IntegralRecord",
      component: componentsBox.IntegralRecord,
      meta: {
        title: meta.IntegralRecord
      }
    },
    {
      path: "/rankingList",
      name: "rankingList",
      component: componentsBox.rankingList,
      meta: {
        title: meta.rankingList
      }
    },
    {
      path: "/activePage",
      name: "activePage",
      component: componentsBox.activePage,
      meta: {
        title: meta.activePages
      }
    },
    {
      path: "/store",
      name: "store",
      component: componentsBox.store,
      meta: {
        title: meta.store
      }
    },
    {
      path: "/goodsDetail",
      name: "goodsDetail",
      component: componentsBox.goodsDetail,
      meta: {
        title: meta.goodsDetail
      }
    },
    {
      path: "/sureMsg",
      name: "sureMsg",
      component: componentsBox.sureMsg,
      meta: {
        title: meta.sureMsg
      }
    },
    {
      path: "/exchange",
      name: "exchange",
      component: componentsBox.exchange,
      meta: {
        title: meta.exchange
      }
    },
    {
      path: "/exchangeDetail",
      name: "exchangeDetail",
      component: componentsBox.exchangeDetail,
      meta: {
        title: meta.exchangeDetail
      }
    },
    {
      path: "/ticket",
      name: "ticket",
      component: componentsBox.ticket,
      meta: {
        title: meta.ticket
      }
    },
    {
      path: "/ticketDetail",
      name: "ticketDetail",
      component: componentsBox.ticketDetail,
      meta: {
        title: meta.ticketDetail
      }
    },
    {
      path: "/",
      name: "login",
      component: resolve => require(["./../mobile/user/info.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/login/:id",
      component: resolve => require(["./../mobile/user/login.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    /**
     * 加热商城
     */
    {
      path: "/hotShopOrder",
      name: "hotShopOrder",
      component: resolve => require(["./../mobile/hotShop/order.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/details",
      name: "details",
      component: resolve =>
        require(["./../mobile/hotShop/details.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/hotShopindex",
      name: "hotShopindex",
      component: resolve => require(["./../mobile/hotShop/index.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/hotshopdetails",
      name: "hotshopdetails",
      component: resolve =>
        require(["./../mobile/hotShop/shopdetails.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/res/:id",
      component: resolve => require(["./../mobile/user/res.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/checkphone",
      component: resolve => require(["./../mobile/user/phone.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/forgetPwd",
      component: resolve =>
        require(["./../mobile/user/forgetPwd.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/my/:id",
      name: "myInfo",
      component: resolve => require(["./../mobile/my/index.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/order/:id",
      component: resolve => require(["./../mobile/order/order.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/ormore/:id/:name",
      component: resolve =>
        require(["./../mobile/order/ordermore.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/car0",
      component: resolve => require(["../mobile/car/emptyCar.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/carType",
      component: resolve => require(["../mobile/car/carType.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/car",
      component: resolve => require(["../mobile/car/car.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/car_kt",
      component: resolve => require(["../mobile/car/car_kt.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      name: "product",
      path: "/product",
      component: resolve => require(["./../mobile/car/product.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      name: "search",
      path: "/search",
      component: resolve => require(["./../mobile/car/search.vue"], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      name: "search_kt",
      path: "/search_kt",
      component: resolve => require(["./../mobile/car/search_kt.vue"], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/carmore/:id",
      component: resolve => require(["./../mobile/car/carmore.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/carmore_kt/:id",
      component: resolve =>
        require(["./../mobile/car/carmore_kt.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/carlist/:id",
      component: resolve => require(["./../mobile/car/carlist.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/carlist_kt/:id",
      component: resolve =>
        require(["./../mobile/car/carlist_kt.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/promore/:id",
      component: resolve => require(["./../mobile/car/promore.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/fuwu",
      name: "fuwu",
      component: resolve =>
        require(["./../mobile/service/carType.vue"], resolve),
      meta: {
        title: "服务站查询"
      }
    },
    {
      path: "/fuwu_jrq",
      name: "fuwu_jrq",
      component: resolve =>
        require(["./../mobile/service/emptyFuwu.vue"], resolve),
      meta: {
        title: "服务站查询",
        keepAlive: false
      }
    },
    {
      path: "/fuwu_kt",
      name: "fuwu_kt",
      component: resolve =>
        require(["./../mobile/service/kt/emptyFuwu.vue"], resolve),
      meta: {
        title: "服务站查询",
        keepAlive: false
      }
    },
    {
      path: "/fuwu0",
      component: resolve => require(["./../mobile/service/fuwu.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/fuwu0_kt",
      component: resolve =>
        require(["./../mobile/service/kt/fuwu.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/fuwuold",
      component: resolve =>
        require(["./../mobile/service/newfuwu.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/searchService",
      component: resolve =>
        require(["./../mobile/service/searchService"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/searchService_kt",
      component: resolve =>
        require(["./../mobile/service/kt/searchService"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/choice",
      component: resolve => require(["./../mobile/tation/choice.vue"], resolve),
      meta: {
        title: "技术资料",
        keepAlive: false
      }
    },
    {
      path: "/teach",
      component: resolve => require(["./../mobile/tation/tation.vue"], resolve),
      meta: {
        title: "技术资料",
        keepAlive: false
      }
    },
    {
      path: "/mod/:type",
      component: resolve => require(["./../mobile/my/mod.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/mymore",
      component: resolve => require(["./../mobile/my/mymore.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/video",
      component: resolve => require(["./../mobile/video/video.vue"], resolve),
      meta: {
        title: "技术资料",
        keepAlive: false
      }
    },
    {
      path: "/comm/:id",
      component: resolve => require(["./../mobile/car/comment.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/jmore/:id",
      component: resolve => require(["./../mobile/my/jmore.vue"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/qa",
      component: resolve => require(["../mobile/QA/index.vue"], resolve),
      meta: {
        title: "故障排查",
        keepAlive: false
      }
    },
    {
      path: "/three/:qatype",
      component: resolve => require(["../mobile/QA/three.vue"], resolve),
      meta: {
        title: "故障排查",
        keepAlive: false
      }
    },
    {
      path: "/four/:qatype",
      component: resolve => require(["../mobile/QA/four.vue"], resolve),
      meta: {
        title: "故障排查",
        keepAlive: false
      }
    },
    {
      path: "/qb/:quesid",
      component: resolve => require(["../mobile/QA/secques.vue"], resolve),
      meta: {
        title: "故障排查",
        keepAlive: false
      }
    },
    {
      path: "/qc/:quesid",
      component: resolve => require(["../mobile/QA/thiques.vue"], resolve),
      meta: {
        title: "故障排查",
        keepAlive: false
      }
    },
    {
      path: "/menu",
      component: resolve => require(["../mobile/user/menu"], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/pdfview",
      name: "pdfview",
      component: resolve => require(["../views/pdfview/index.vue"], resolve),
      meta: {
        title: "保修证明"
      }
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "终端用户";
  }
  next();
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
export default router;



// WEBPACK FOOTER //
// ./src/router/router-mod.js